// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isSegmentEngagementsResult = objectOf({
  campaigns_using_segment: objectOf({
    count: number,
    data: arrayOf(string),
  }),
  cards_using_segment: objectOf({
    count: number,
    data: arrayOf(string),
  }),
  workflows_using_segment: objectOf({
    count: number,
    data: arrayOf(string),
  }),
  segments_using_segment: objectOf({
    count: number,
    data: arrayOf(string),
  }),
});
